'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (input) {
  if (!(typeof input === 'string' || input instanceof String)) {
    throw new TypeError('[latin-to-serbian-cyrillic] - input must be a string');
  }

  var latin = input.slice();
  Object.keys(_map2.default).forEach(function (letter) {
    latin = latin.split(letter).join(_map2.default[letter]).split(letter.toLocaleUpperCase()).join(_map2.default[letter].toLocaleUpperCase());
  });
  return latin;
};

var _map = require('./map');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/*!
 * latin-to-serbian-cyrillic
 * Author: Igor Šćekić <igorscekic2@gmail.com>
 * License: MIT
 */


;
/**
 * converts a latin string to serbian cyrillic
 *
 * @param {string} input latin string to be converted
 * @returns {string} cyrillic string
 */

module.exports = exports['default'];